import { css, createGlobalStyle } from 'styled-components'
import WuerthExtraBoldCond from '../fonts/wuerthbold_webfont3_2.woff2'
import WuerthBook from '../fonts/wuerthbook_webfont3_2.woff2'

const GlobalStyle = createGlobalStyle(
  props => css`
    @font-face {
      font-family: 'Wuerth';
      src: url(${WuerthBook});
      font-style: normal;
      font-weight: normal;
    }
    @font-face {
      font-family: 'Wuerth';
      src: url(${WuerthExtraBoldCond});
      font-style: normal;
      font-weight: bold;
    }
    html {
      font-size: 62.5%;
    }
    body {
      font-family: ${props.theme.fontFamily}, 'Futura Bk BT', 'Futura T OT', Arial, Verdana,
        'Microsoft Yahei', '微软雅黑', sans-serif;
      margin: 0;
      font-weight: 300;
      color: ${props.theme.colorBlack};
    }
    p {
      margin: 0;
    }
    .ant-select-item {
      background: white !important;
    }
    .ant-select-item-option-active {
      background: ${props.theme.colorRedTransparent} !important;
    }
    .ant-btn:focus,
    .ant-btn:active {
      border: inherit;
    }
    .ant-progress {
      .ant-progress-inner {
        background-color: ${props.theme.colorWhite};
        border-radius: 0;
      }
      .ant-progress-bg {
        background-color: ${props.theme.colorRed};
        border-radius: 0;
        height: 4px !important;
      }
    }
  `
)

export default GlobalStyle
